/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SearchBar_viewer = {|
  +isSuggestionsFeatureEnabled: ?boolean;
  +searchSuggestions?: ?{|
    +suggestions: ?$ReadOnlyArray<?{|
      +type: ?string;
      +terms: ?$ReadOnlyArray<?{|
        +term: ?string;
        +urlLabel: ?string;
      |}>;
    |}>;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "query",
      "type": "String!",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "hasQuery",
      "type": "Boolean!",
      "defaultValue": false
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SearchBar_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSuggestionsFeatureEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SEARCH_BAR_SUGGESTIONS",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"SEARCH_BAR_SUGGESTIONS\"}"
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasQuery",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "includeTypes",
              "value": [
                "POPULAR",
                "CATEGORY",
                "SELLER"
              ],
              "type": "[String]"
            },
            {
              "kind": "Variable",
              "name": "query",
              "variableName": "query",
              "type": "String!"
            }
          ],
          "concreteType": "SearchSuggestion",
          "name": "searchSuggestions",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "SearchSuggestionList",
              "name": "suggestions",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "type",
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "SearchSuggestionTerm",
                  "name": "terms",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "term",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "urlLabel",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
